<template>
  <div>
    <h2 class="mb-1 mt-0">Welcome back!</h2>
    <p class="lead mb-2 mt-0">Enter your email and password below.</p>
    <form @submit.prevent="attemptLogin">
      <div class="mb-2">
        <v-input
          placeholder="Enter your email"
          type="email"
          name="email"
          v-model="vEmail"
        ></v-input>
      </div>
      <div class="mb-2">
        <v-input
          required
          placeholder="Password"
          v-model="password"
          type="password"
          name="password"
          :autofocus="!isIos()"
        ></v-input>
      </div>
      <v-button
        key="login-submit"
        :is-loading="isLoading"
        block
        class="mb-2"
        type="submit"
      >
        {{ submitText }}
      </v-button>
    </form>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"

import { isIos } from "@/lib/is-platform"

import vInput from "@/components/forms/vInput"

export default {
  components: {
    vInput
  },

  props: {
    email: { type: String },
    submitText: { type: String, default: "Login" }
  },

  data() {
    return {
      isLoading: false,
      vEmail: "",
      password: ""
    }
  },

  mounted() {
    this.vEmail = this.email
  },

  computed: {
    ...mapState("auth", ["user"])
  },

  methods: {
    isIos,

    ...mapActions("auth", ["login"]),

    attemptLogin() {
      this.isLoading = true

      this.login({ email: this.vEmail, password: this.password })
        .then(() => this.$emit("login"))
        .catch(err => this.$notify(err.message))
        .then(() => (this.isLoading = false))
    }
  }
}
</script>
